// assets
import { BookOutlined } from '@ant-design/icons';

// icons
const icons = {
  BookOutlined
};

// ==============================|| MENU ITEMS - TEACHING ||============================== //

const instructor = {
  id: 'group-teaching',
  title: 'Teaching',
  type: 'group',
  children: [
    {
      id: 'instructor-courses',
      title: 'My Courses',
      type: 'item',
      url: '/instructor',
      icon: icons.BookOutlined,
      breadcrumbs: false
    }
  ]
};

export default instructor;
